import { useMutation, gql } from '@apollo/react-hooks';
import { useCallback } from 'react';
import type { DeleteCapitalNeedMutation } from '#/graphql/types';
import { deleteCapitalNeed } from '#/graphql/mutations';
import { get } from 'lodash';
import { GET_ASSET_RELATED_COUNTS } from '#/modules/asset/hooks/useAssetRelatedCountsQuery';

const q = gql(deleteCapitalNeed);

const useCapitalNeedDelete = () => {
  const [mutation, result] = useMutation<DeleteCapitalNeedMutation>(q);
  const deleteCapitalNeed = useCallback(
    async (itemId: string, assetId?: string) => {
      const refetchQueries: {
        query: typeof GET_ASSET_RELATED_COUNTS;
        variables?: { assetId: string };
      }[] = [];

      if (assetId) {
        refetchQueries.push({ query: GET_ASSET_RELATED_COUNTS, variables: { assetId } });
      }

      const response = await mutation({
        variables: {
          id: itemId,
        },
        refetchQueries,
        awaitRefetchQueries: true,
      });

      return get(response, 'data.deleteCapitalNeed.data', undefined);
    },
    [mutation],
  );

  return { deleteCapitalNeed, result };
};

export default useCapitalNeedDelete;
